export default __webpack_public_path__ + "locales/es/EmptyTrashDialog.json?hash=1a39dc6a9b9ecf9a716731e5c4b6e64e";